import { get, post } from "../client";

/**
 * Native invoicing — talks to /v1/documents on the Backend.
 * Phase 1: list, get one, issue (305/400/330/320), credit, pdf.
 */
export default {
  list: async (params = {}) => {
    const clean = Object.fromEntries(
      Object.entries(params).filter(([, v]) => v !== "" && v !== undefined && v !== null)
    );
    const qs = new URLSearchParams(clean).toString();
    return await get(`/documents${qs ? "?" + qs : ""}`);
  },
  get_one: async (id) => await get(`/documents/${id}`),
  get_pdf: async (id) => await get(`/documents/${id}/pdf`),
  issue: async (data) => (await post("/documents", data)).data,
  credit: async (id, reason) => (await post(`/documents/${id}/credit`, { reason })).data,
  get_setup: async () => await get("/documents/setup"),
  post_setup: async (data) => (await post("/documents/setup", data)).data,

  // Save-in-debt (שמירה בחוב). `issueDoc: true` also emits a 320; `false`
  // creates a ledger-only entry.
  save_debt: async (data) => (await post("/documents/save-debt", data)).data,
  list_debts: async (params = {}) => {
    const clean = Object.fromEntries(
      Object.entries(params).filter(([, v]) => v !== "" && v !== undefined && v !== null)
    );
    const qs = new URLSearchParams(clean).toString();
    return await get(`/documents/debts${qs ? "?" + qs : ""}`);
  },
  mark_debt_paid: async (id) => (await post(`/documents/debts/${id}/mark-paid`)).data,
};
